import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import DishCard from '../components/DishCard';

const CATEGORIES = [
  { id: 'all',     label: 'Всі' },
  { id: 1,         label: 'Гриль' },
  { id: 5,         label: 'Гарніри' },
  { id: 2,         label: 'Гарячі страви' },
  { id: 12,        label: 'Перші страви' },
  { id: 3,         label: 'Холодні закуски' },
  { id: 11,        label: 'Салати' },
  { id: 4,         label: 'Дитяче меню' },
  { id: 6,         label: 'Десерти' },
  { id: 7,         label: 'Гарячі напої' },
];
function useIsMobile() {
  const [v, setV] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setV(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return v;
}

const PremiumFilterHeart = ({ active }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill={active ? "#fff" : "#e74c3c"} stroke={active ? "#fff" : "#e74c3c"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

// ДОДАНО: initialCategory в props
export default function MenuPage({ cart, onAdd, initialCategory }) {
  const [dishes, setDishes]       = useState([]);
  const [loading, setLoading]     = useState(true);

  // ОНОВЛЕНО: Якщо передали initialCategory, робимо її активною з самого початку
  const [activeCat, setActiveCat] = useState(initialCategory || 'all'); 

  const [search, setSearch]       = useState('');
  const [gridKey, setGridKey]     = useState(0);
  const isMobile = useIsMobile();

  // ref для горизонтального рядка категорій
  const catScrollRef = useRef(null);
  // ref для області прокрутки (щоб скролити меню вгору при зміні категорії)
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = catScrollRef.current;
    if (!el) return;
    const onWheel = (e) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, []);

  // Активну категорію автоматично підкручуємо у видиму частину рядка
  useEffect(() => {
    const bar = catScrollRef.current;
    if (!bar) return;
    const activeEl = bar.querySelector('[data-active="true"]');
    if (activeEl) activeEl.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }, [activeCat]);

  // ДОДАНО: Якщо initialCategory змінилась (хтось знову натиснув з головної), оновлюємо
  useEffect(() => {
    if (initialCategory) {
      setActiveCat(initialCategory);
      setGridKey(k => k + 1);
    }
  }, [initialCategory]);

  useEffect(() => {
    if (sessionStorage.getItem('goToFavs') === 'true') {
      setActiveCat('favorites');
      sessionStorage.removeItem('goToFavs');
    }
    const handleShowFavs = () => setActiveCat('favorites');
    window.addEventListener('showFavorites', handleShowFavs);
    return () => window.removeEventListener('showFavorites', handleShowFavs);
  }, []);

  useEffect(() => {
    api.get('/dishes')
      .then(r => setDishes(r.data))
      .catch(() => setDishes([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleLikeUpdate = () => setGridKey(k => k + 1);
    window.addEventListener('likeUpdated', handleLikeUpdate);
    return () => window.removeEventListener('likeUpdated', handleLikeUpdate);
  }, []);

  const handleCat = (id) => {
    setActiveCat(id);
    setGridKey(k => k + 1);
    setSearch('');
    // прокручуємо меню на початок обраної категорії
    if (scrollRef.current) scrollRef.current.scrollTo({ top: 0, behavior: 'auto' });
  };

  const filtered = dishes.filter(d => {
    if (activeCat === 'favorites') {
      const isLiked = localStorage.getItem(`liked_${d.id}`) === 'true';
      const matchSearch = !search || d.name.toLowerCase().includes(search.toLowerCase()) || (d.description || '').toLowerCase().includes(search.toLowerCase());
      return isLiked && matchSearch;
    }
    if (['8', '9', '10'].includes(String(d.category_id))) return false;
    let matchCat = activeCat === 'all' || String(d.category_id) === String(activeCat);
    const matchSearch = !search || d.name.toLowerCase().includes(search.toLowerCase()) || (d.description || '').toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  const pad = isMobile ? '12px' : '20px';

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {!isMobile && (
        <div style={{
          background: '#0d0d0b', padding: '24px 28px 20px',
          position: 'relative', overflow: 'hidden', flexShrink: 0,
        }}>
          <div className="hero-tag" style={{
            fontSize: 10, letterSpacing: '2.5px', textTransform: 'uppercase',
            color: '#c8b89a', fontWeight: 300, marginBottom: 8,
          }}>Ресторан «Околиця» · Якушинці</div>
          <div className="hero-title" style={{
            fontFamily: "'Fraunces', serif", fontSize: 34, fontWeight: 300,
            lineHeight: 1.1, color: '#fff',
          }}>
            Оберіть{' '}
            <em style={{ fontStyle: 'italic', color: '#e8c97e' }}>страву</em>
          </div>
          <div className="hero-desc" style={{
            fontSize: 13, color: 'rgba(255,255,255,0.45)',
            marginTop: 6, fontWeight: 300,
          }}>
            Домашня кухня · Свіжі продукти
          </div>
          <div style={{
            position: 'absolute', right: 24, top: '50%',
            transform: 'translateY(-50%)',
            width: 70, height: 70, borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.1)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 18, color: 'rgba(255,255,255,0.2)',
          }}>✦</div>
        </div>
      )}

      {/* Область прокрутки: пошук гортається, рядок категорій лишається приклеєним */}
      <div ref={scrollRef} style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>

        {/* Пошук та Обране — гортаються разом з контентом */}
        <div style={{ display: 'flex', gap: 12, padding: `14px ${pad} 0`, alignItems: 'center' }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Пошук страви..."
            style={{
              flex: 1, padding: '12px 18px', height: 46,
              border: '1px solid #e8ddd0', borderRadius: 24,
              fontSize: 14, background: '#fff', color: '#0d0d0b', outline: 'none',
              transition: 'all 0.25s ease',
              boxShadow: '0 2px 10px rgba(0,0,0,0.02)'
            }}
            onFocus={e => {
              e.target.style.borderColor = '#d4af37';
              e.target.style.boxShadow = '0 0 0 4px rgba(212,175,55,0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e8ddd0';
              e.target.style.boxShadow = '0 2px 10px rgba(0,0,0,0.02)';
            }}
          />
          <button
            onClick={() => handleCat(activeCat === 'favorites' ? 'all' : 'favorites')}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: isMobile ? '0 16px' : '0 20px', height: 46,
              borderRadius: 24, border: activeCat === 'favorites' ? 'none' : '1px solid #e8ddd0',
              background: activeCat === 'favorites' ? 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)' : '#fff',
              color: activeCat === 'favorites' ? '#fff' : '#6b6560',
              fontWeight: 500, fontSize: 14, cursor: 'pointer',
              transition: 'all 0.25s ease',
              boxShadow: activeCat === 'favorites' ? '0 6px 16px rgba(231,76,60,0.25)' : '0 2px 10px rgba(0,0,0,0.02)',
              flexShrink: 0
            }}
            onMouseEnter={e => { if (activeCat !== 'favorites') { e.currentTarget.style.borderColor = '#e74c3c'; e.currentTarget.style.color = '#e74c3c'; } }}
            onMouseLeave={e => { if (activeCat !== 'favorites') { e.currentTarget.style.borderColor = '#e8ddd0'; e.currentTarget.style.color = '#6b6560'; } }}
          >
            <PremiumFilterHeart active={activeCat === 'favorites'} /> {!isMobile && 'Обране'}
          </button>
        </div>

        {/* ЛИПКИЙ рядок категорій — лишається приклеєним зверху при прокрутці */}
        <div ref={catScrollRef} style={{
          position: 'sticky', top: 0, zIndex: 5,
          display: 'flex', gap: 10, padding: `14px ${pad}`,
          overflowX: 'auto', borderBottom: '1px solid #f2efea',
          background: 'var(--paper)',
          boxShadow: '0 6px 14px rgba(13,13,11,0.04)',
          scrollbarWidth: 'thin', WebkitOverflowScrolling: 'touch'
        }}>
          {CATEGORIES.map(cat => {
            const isActive = activeCat === cat.id;
            return (
              <button key={cat.id} className="cat-chip"
                data-active={isActive ? 'true' : undefined}
                onClick={() => handleCat(cat.id)}
                style={{
                  padding: isMobile ? '10px 18px' : '12px 22px', 
                  borderRadius: 30,
                  fontSize: isMobile ? 13 : 14,
                  whiteSpace: 'nowrap', 
                  border: isActive ? '1px solid transparent' : '1px solid #e8ddd0',
                  background: isActive ? 'linear-gradient(135deg, #2a2a2a 0%, #0d0d0b 100%)' : '#fff',
                  color: isActive ? '#e8c97e' : '#8c857d',
                  fontWeight: isActive ? 600 : 500,
                  boxShadow: isActive ? '0 6px 16px rgba(0,0,0,0.15)' : '0 2px 6px rgba(0,0,0,0.02)',
                  cursor: 'pointer', transition: 'all 0.25s ease'
                }}
                onMouseEnter={e => {
                  if (!isActive) {
                    e.currentTarget.style.background = '#faf7f3';
                    e.currentTarget.style.borderColor = '#d4af37';
                    e.currentTarget.style.color = '#0d0d0b';
                  }
                }}
                onMouseLeave={e => {
                  if (!isActive) {
                    e.currentTarget.style.background = '#fff';
                    e.currentTarget.style.borderColor = '#e8ddd0';
                    e.currentTarget.style.color = '#8c857d';
                  }
                }}
              >{cat.label}</button>
            );
          })}
        </div>

        {/* Сітка страв */}
        <div key={gridKey} style={{
          padding: `16px ${pad} 24px`,
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: isMobile ? 12 : 16,
          alignContent: 'start',
        }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#8c857d', gridColumn: '1/-1' }}>
              Завантаження меню...
            </div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#8c857d', fontSize: 14, gridColumn: '1/-1' }}>
              {activeCat === 'favorites' ? 'У вас поки немає обраних страв 🤍' : 'Нічого не знайдено 🔍'}
            </div>
          ) : (
            filtered.map(dish => (
              <DishCard key={dish.id} dish={dish} qty={cart ? cart[dish.id]?.qty : 0} onAdd={onAdd} />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
